export const REQUEST_PLAN_CREATE = 'REQUEST_PLAN_CREATE';
export const PLAN_CREATE_REQUEST_COMPLETED = 'PLAN_CREATE_REQUEST_COMPLETED';
export const PLAN_CREATE_REQUEST_FAILED = 'PLAN_CREATE_REQUEST_FAILED';
export const PLAN_RESET_STATE = 'PLAN_RESET_STATE';

export const PLAN_CREATE_SET_GLOBAL_ERROR = 'PLAN_CREATE_SET_GLOBAL_ERROR';
export const PLAN_CREATE_RESET_GLOBAL_ERROR = 'PLAN_CREATE_RESET_GLOBAL_ERROR';
